import { Lightbulb, X } from "lucide-react";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "~/components/ui/button";
import { useChatDisclaimerStore } from "../stores/chatDisclaimerStore";

export const ChatDisclaimerBanner: FC = () => {
  const isDismissed = useChatDisclaimerStore((state) => state.isDismissed);
  const dismiss = useChatDisclaimerStore((state) => state.dismiss);

  if (isDismissed) {
    return null;
  }

  return (
    <div className="mx-3 mt-3 flex items-start gap-2 rounded-lg border border-border bg-muted/50 px-3 py-2 text-xs text-muted-foreground">
      <Lightbulb className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span className="flex-1">
        <FormattedMessage id="chat.disclaimer.text" />
      </span>
      <Button
        variant="ghost"
        size="icon"
        className="h-5 w-5 shrink-0"
        onClick={dismiss}
        aria-label="Dismiss"
      >
        <X className="h-3 w-3" />
      </Button>
    </div>
  );
};
